import { Grid } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Screen from '../../components/fragments/Screen';

export default function Chapters() {
    const [chapters, setChapters] = useState([]);

    const navigate = useNavigate();
    const { version: bibleId, book: bookId } = useParams();

    useEffect(() => {
        axios
            .get(
                `https://api.scripture.api.bible/v1/bibles/${bibleId}/books/${bookId}/chapters`,
                {
                    headers: {
                        'api-key': '74d66efbae53bab5516e6c50cbaf17ea',
                    },
                }
            )
            .then((resp) => {
                setChapters(resp?.data?.data);
            });
    }, [bibleId, bookId]);

    return (
        <Screen loading={!chapters.length} authPass title={`Chapters`}>
            {chapters
                .filter(({ number }) => number !== 'intro')
                ?.map(({ id, number }) => (
                    <Grid key={id} item xs={2}>
                        <div
                            key={id}
                            className="text-center p-1"
                            style={{ border: '1px solid #ddd' }}
                            onClick={() =>
                                navigate(`/bible/${bibleId}/${bookId}/${id}`)
                            }
                        >
                            {number}
                        </div>
                    </Grid>
                ))}
        </Screen>
    );
}
